import styled from 'styled-components';
import { rem } from 'polished';
import { ModalRemovePxConfirmationStyled } from '../ModalRemovePxConfirmationStyled';

export const ModalRemovePxConfirmationStyledDS = styled(ModalRemovePxConfirmationStyled)`
    
`;
